import {SingleAccountEquityWizardData} from "../models/MultiAccountEquityWizardData";
import {OrderPlaceConditions} from "../../services/models/PlaceOrderRequest";
import {OrderSide} from "../../../../../orders/models/OrderRecord";
import {DateTimeUtil} from "../../../../../js/util/DateTimeUtil";
import {Optional} from "../../../../../js/util/Optional";
import {Equality} from "../../../../../types/GenericTypes";
import {Condition, PriceBase} from "../../../../../orders/models/OrderConditions";
import {
    MultiAccountOrderRequest,
    SingleAccountEquityOrderRequest
} from "../../services/models/PlaceMultiAccountOrderRequest";
import {OrderAdvice} from "../../place-order-wizard/models/OrderAdvice";
import {EquityWizardData} from "../../place-equity-order-wizard/models/EquityWizardData";

export function extractOrderRequest(data: EquityWizardData[]): MultiAccountOrderRequest | null {
    if (data == null) {
        return null;
    } else {
        const orders = buildOrderRequest(data);
        return orders;
    }
}

export function buildOrderRequest(data: EquityWizardData[]): MultiAccountOrderRequest {

    const ordersRequest = data && data?.length > 0 ? data?.map(
        (single) => {
            try {
                const conditions = orderConditions(single);
                const expires = Optional.of(single)
                                        .map((d) => d.expiry)
                                        .map((d) => DateTimeUtil.dateToIso(d))
                                        .orNull();

                return {
                    portfolioId: single.portfolio?.id,
                    placeOrderRequest: {
                        code: single.code ? single.code : "",
                        exchange: single.exchange,
                        description: "",
                        buy: single.side === OrderSide.BUY,
                        quantity: single.quantity,
                        limit: single.limit ?? 0,
                        pricingInstruction: single.pricingInstruction,
                        lifetime: single.lifetime,
                        expires,
                        legs: [],
                        tmcOverride: false,
                        advice: single.advice,
                        conditions,
                        isParentOrder: false,
                        childOrders: []
                    }
                };
            } catch (error) {
                console.error("Error building order request:", error);
            }
        }
    ) : [];

    return {
        // @ts-ignore
        orders: ordersRequest
    };

}

export function buildSingleOrderRequest(data: SingleAccountEquityWizardData, orderAdvice?: OrderAdvice): SingleAccountEquityOrderRequest {
    const conditions = orderConditions(data);
    const expires = Optional.of(data)
                            .map((d) => d.expiry)
                            .map((d) => DateTimeUtil.dateToIso(d))
                            .orNull();

    return {
        portfolioId: data.portfolio?.id ?? 0,
        placeOrderRequest: {
            code: data.code ? data.code : "",
            exchange: data.exchange,
            description: "",
            buy: data.side === OrderSide.BUY,
            quantity: data.quantity,
            limit: data.limit ?? 0,
            pricingInstruction: data.pricingInstruction,
            lifetime: data.lifetime,
            expires,
            legs: [],
            tmcOverride: false,
            advice: orderAdvice,
            conditions,
            isParentOrder: false,
            childOrders: []
        }
    };
}

function orderConditions(data: SingleAccountEquityWizardData): OrderPlaceConditions | null {
    if (data.isStopLoss && data.stopLossLimit != null) {
        return {
            priceBase: PriceBase.LAST,
            condition: Condition.LESS_OR_EQUAL,
            price: data.stopLossLimit!
        };
    } else {
        return null;
    }
}

/* Checks if the values required for a brokerage request have changed */
export function isSameBrokerageRequest(): Equality<SingleAccountEquityOrderRequest> {
    return (a, b) => (a.portfolioId === b.portfolioId) &&
        (a.placeOrderRequest.code === b.placeOrderRequest.code) &&
        (a.placeOrderRequest.exchange === b.placeOrderRequest.exchange) &&
        (a.placeOrderRequest.buy === b.placeOrderRequest.buy) &&
        (a.placeOrderRequest.quantity === b.placeOrderRequest.quantity) &&
        (a.placeOrderRequest.pricingInstruction === b.placeOrderRequest.pricingInstruction) &&
        (a.placeOrderRequest.limit === b.placeOrderRequest.limit);
}
